<template>
  <section class="customizer-legacy-navigation">
    <div
      class="customizer-legacy-navigation-flyout"
      :class="[{
        'customizer-legacy-navigation-flyout--external-header': externalHeadersVisible
      }]"
      v-show="showFlyout"
    >
      <div
        class="customizer-legacy-navigation-flyout-close-btn"
        @click="closeFlyout">
        <span class="icon-close"></span>
      </div>
      <div class="customizer-legacy-navigation-flyout-steps">
          <ul class="customizer-legacy-navigation-flyout-steps-list">
            <li
              v-for="item in menu"
              @click="selectComponent(item.name, $customizerDataLayer.types.selectComponentMenu, true, item.display_name)"
              :key="item.name"
              :class="[
                'customizer-legacy-navigation-flyout-steps-item',
                item.name,
                { disabled: rayTracerDisabled }
              ]"
            >
              <span :class="[
                'icon',
                item.item_state ? 'icon-check' : 'list-configurator-bullet'
                ]"></span>
              <span class="customizer-legacy-navigation-flyout-steps-item-name">{{ item.display_name }}</span>

              <span
                v-if="item.hasUGC && isUGCEnabled && noPaletteLockOrUniqueSwatches"
                @click.stop="openUGC($event, item.name)"
                :class="[
                  'icon-camera customizer-legacy-navigation-flyout-steps-item-ugc',
                  { disabled : areUGCIconsDisabled || rayTracerDisabled },
                  { hide : configuration.enableCollapsingSwatches && areUGCIconsDisabled }
                ]"
              >
                </span>
              <span
                v-if="item.hasPersonalization && isPersonalizationEnabled && noPaletteLockOrUniqueSwatches"
                @click.stop="openPersonalization($event, item.name)"
                :class="[
                  'icon-edit customizer-legacy-navigation-flyout-steps-item-personalization',
                  { disabled : isPersonalizationIconDisabled || rayTracerDisabled },
                  { hide : configuration.enableCollapsingSwatches && isPersonalizationIconDisabled }
                ]"
              ></span>
            </li>
          </ul>
      </div>
      <div
        @click="startOver"
        :class="[
          'customizer-legacy-navigation-flyout-start-over',
          { disabled : rayTracerDisabled }
        ]"
      >
        <span  class="customizer-legacy-navigation-flyout-start-over-icon icon-redo"></span>
        {{ translations.headerStartOver }}
      </div>
    </div>

    <div :class="['customizer-legacy-navigation-main', this.themeMenu]" :style="themeMenuStyle">
      <div class="customizer-legacy-navigation-main-labels">
          <p class="customizer-legacy-navigation-main-labels-numbers">
            {{ currentComponentNumber }} / {{ visibleComponentsNumber }}
          </p>
          <h2 class="customizer-legacy-navigation-main-labels-component-name" v-if="this.menu[activeComponent]">
            <span>
              {{ this.menu[activeComponent].display_name }}
            </span>
          </h2>
      </div>
      <div class="customizer-legacy-navigation-main-steps">
          <div
            @click="openCloseFlyout"
            :class="[
              'customizer-legacy-navigation-main-steps-open-flyout-button customizer-legacy-navigation-main-button',
              { disabled: rayTracerDisabled }
            ]"
          >
              <span class="customizer-legacy-navigation-main-button-icon icon-menu"></span>
          </div>
          <div
            @click="changeComponent('previous')"
            :class="[
              'customizer-legacy-navigation-main-steps-open-prev customizer-legacy-navigation-main-button',
              { disabled: rayTracerDisabled }
            ]"
          >
              <span class="customizer-legacy-navigation-main-button-icon icon-arrow-left-indicator"></span>
          </div>
          <div
            @click="changeComponent()"
            :class="[
              'customizer-legacy-navigation-main-steps-open-next customizer-legacy-navigation-main-button',
              { disabled: rayTracerDisabled }
            ]"
            >
              <span class="customizer-legacy-navigation-main-button-icon icon-arrow-right-indicator"></span>
          </div>
      </div>
    </div>
  </section>
</template>
<script>
import { themePalette } from '@/data/constants';
import { checkerboardSwatches } from '@/components/CustomCheckerboard/MainViews/SizeSelector/combinations'

export default {
  name: "legacyNavigation",
  data() {
    return {
      showFlyout: false,
      areUGCIconsDisabled: false,
      isPersonalizationIconDisabled: false
    }
  },
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    pdm(){
      return this.$store.state.utils.pdm;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    defaultRecipe() {
      return this.$store.state.recipe.defaultRecipe;
    },
    initRecipe() {
      return this.$store.state.recipe.initRecipe;
    },
    activeComponent() {
      return this.$store.state.legacyNavigation.activeComponent;
    },
    queryParams() {
      return this.$store.state.utils.queryParams;
    },
    menu() {
      const fullMenu = this.$store.state.legacyNavigation.menu;
      const menu = {};

      const components = Object.keys(fullMenu);
      components.forEach((componentName) => {
        if(fullMenu[componentName].visible) {
          menu[componentName] = { ...fullMenu[componentName] };
        }
      });

      return menu;
    },
    currentComponentNumber() {
      let count = 0;

      for (let component in this.menu) {
        count++;

        if (component === this.activeComponent) {
          break;
        }
      }

      return count;
    },
    visibleComponentsNumber() {
      return Object.keys(this.menu).length;
    },
    totalComponentsNumber() {
      return Object.keys(this.$store.state.legacyNavigation.menu).length;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    rayTracerDisabled() {
      return this.$store.state.utils.trayDisabled.swatches || this.$store.state.utils.trayDisabled.geostates;
    },
    isSplashModalOpen() {
      return this.$store.state.utils.isSplashModalOpen;
    },
    noPaletteLockOrUniqueSwatches() {
      return !(this.$store.getters['swatches/lockedPalettes'].length + this.$store.getters['swatches/uniqueSwatches'].length);
    },
    isUGCEnabled() {
      return this.$store.getters["utils/isUGCenabled"];
    },
    isPersonalizationEnabled() {
      return this.$store.getters["utils/isPersonalizationEnabled"];
    },
    customsAssets() {
      return this.$store.state.endPoints.customizer.customsAssets;
    },
    paletteTheme() {
      return this.$store.state.swatches.paletteTheme;
    },
    themeMenu() {
      const flyout_menu_class = this.paletteTheme && this.paletteTheme.palette_features && this.paletteTheme.palette_features.flyout_menu_class;
      return flyout_menu_class ? themePalette.themePrefix + flyout_menu_class : false;
    },
    themeMenuStyle() {
      if (this.themeMenu) {
        return {
          "background-image": `url(${this.customsAssets}/images/customizer/themes/${this.paletteTheme.tab_id}/${this.paletteTheme.palette_features.flyout_menu_src})`
        };
      }
      return false;
    },
    externalHeadersVisible() {
      return this.$store.state.utils.externalHeadersVisible && !this.$store.getters['utils/regionIsApac'];
    },
  },
  watch: {
    defaultRecipe(newVal) {
      if (newVal !== undefined && this.pdm) {
        this.selectComponent(this.$recipe.getRecipeDefaultComponent(), null, false, null);
        this.createMainNav();
      }
    },
    recipe_v2: {
      handler(newVal) {
        if (!this.isSplashModalOpen && !this.$store.state.utils.isDesignTransfering) {
          const recipeV2Component = this.recipe_v2.components && this.recipe_v2.components[this.activeComponent];
          const initRecipeComponent = this.initRecipe.components && this.initRecipe.components[this.activeComponent];
          // checkerboardSwatches.includes(recipeV2Component.swatch_id) Means that the icon will be updated with the
          // emit once the swatch is applied.
          if (recipeV2Component &&
              initRecipeComponent &&
              recipeV2Component.swatch_id !== initRecipeComponent.swatch_id &&
              !checkerboardSwatches.includes(recipeV2Component.swatch_id)
            ) {
            this.updateMenuItemState();
          }
        }
      },
      deep: true
    },
    isSplashModalOpen(newVal) {
      if (newVal === true) {
        this.closeFlyout();
      }
    }
  },
  methods: {
    createMainNav() {
      const componentsSwatchApplied = this.$recipe.getComponentsSwatchApplied();
      this.pdm.component_order.forEach((componentName, index) => {
        const pdmComponent = this.pdm.components[componentName];
        const componentInRecipe = this.recipe_v2.components[componentName];
        const position = index + 1;
        this.$store.commit("legacyNavigation/CREATE_MENU_ITEM", {
          componentName,
          componentData: {
            item_state: componentsSwatchApplied.includes(componentName),
            name: componentName,
            display_name: this.translations[`component${componentName}`],
            original_position: position,
            visible: componentInRecipe ? true : false,
            active: false,
            hasUGC: pdmComponent.hasOwnProperty('ugc'),
            hasPersonalization: this.pdm.components.personalization && this.pdm.components.personalization.personalization_sibling_component === componentName
          }
        });
      });
    },
    setPreviousComponent() {
      this.$store.commit('legacyNavigation/SET_PREVIOUS_COMPONENT', this.activeComponent);
        const swatchObj = this.$store.state.swatches.selectedSwatches[this.activeComponent];
        if (swatchObj && !swatchObj.default) {
          this.$store.commit('legacyNavigation/SET_LAST_COMPONENT_SWATCH_APPLIED', this.activeComponent);
      }
    },
    selectComponent(componentName, dataLayerType = null, setRotate = true, componentDisplayName = '', componentHighlighting = true) {
      if (this.rayTracerDisabled && !this.$store.state.utils.isRandomizeApplied) return;

      if (setRotate && this.configuration.enableAutoRotate && this.pdm.components[componentName].position_component) {
        componentHighlighting && this.$eventBus.$emit("rotate-component", this.pdm.components[componentName].position_component, componentName);
      } else {
        this.$eventBus.$emit("component-selected", componentName);
      }
      if(this.$store.getters["utils/returnScreenSize"].includes('mobile')){
          this.closeFlyout();
      }

      if (this.activeComponent !== componentName) {
        this.setPreviousComponent();
      }
      this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', componentName);
      const componentsWithUGC = this.$store.getters['ugc/getUGCEnabledComponents'];
      if (componentsWithUGC.includes(componentName)) {
        this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', componentName);
      }

      if (dataLayerType) {
        this.setDataLayer(componentDisplayName, dataLayerType);
      }
    },
    openCloseFlyout() {
      if (this.rayTracerDisabled || this.isSplashModalOpen) return;

      this.showFlyout = !this.showFlyout;
      this.$eventBus.$emit("rotate-stop", false);
    },
    closeFlyout() {
      this.showFlyout = false;
    },
    openUGC($event, component) {
      if($event.currentTarget.classList.contains('disabled')) {
        return false;
      };

      this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', component);
      this.$nextTick(() => this.$eventBus.$emit("changeTab", { name: "add-your-own" }));
    },
    openPersonalization($event, component) {
      if($event.currentTarget.classList.contains('disabled')) {
        return false;
      }
      if (!this.configuration.enableAutoRotate) {
        this.$store.commit('legacyNavigation/SET_ACTIVE_COMPONENT', component);
      }
      if (this.isPersonalizationEnabled) {
        if (this.configuration.modals?.embroidery) {
          this.$modal.show('embroideryModal');
        } else {
          this.$modal.show('newEmbroideryModal');
        }
      }
      else {
        this.$modal.show('personalization');
      }
    },
    startOver() {
      if (this.rayTracerDisabled) return;

      const recipeId = this.queryParams.recipe || this.pdm.default_recipe;
      this.$modal.show("startOverModal", { recipeId });
      this.closeFlyout();
    },
    getComponentByPosition(position) {
      for (let component in this.menu) {
        if(this.menu[component].original_position === position) {
          return this.menu[component].name;
        }
      }

      return null;
     },
    changeComponent(action) {
      if (this.rayTracerDisabled || this.isSplashModalOpen) {
        return;
      }

      const menuArray = JSON.parse(JSON.stringify(this.menu));
      let newPosition = menuArray[this.activeComponent].original_position;
      let newComponentName = this.activeComponent;

      while(!newComponentName || newComponentName === this.activeComponent) {
        if (action === 'previous') {
          newPosition =  newPosition <= 1 ? this.totalComponentsNumber : newPosition - 1;
        } else {
          newPosition = newPosition >= this.totalComponentsNumber ? 1 : newPosition + 1;
        }

        newComponentName = this.getComponentByPosition(newPosition);
      }

      if (this.configuration.enableAutoRotate && this.pdm.components[newComponentName].position_component) {
        this.$eventBus.$emit("rotate-component", this.pdm.components[newComponentName].position_component, newComponentName);
      } else {
        this.$eventBus.$emit("component-selected", newComponentName);
      }

      if (this.activeComponent !== newComponentName) {
        this.setPreviousComponent();
      }

      this.$store.commit("legacyNavigation/SET_ACTIVE_COMPONENT", newComponentName);

      if (this.$store.getters['ugc/getUGCEnabledComponents'].includes(newComponentName)) {
        this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', newComponentName);
      }

      this.setDataLayer(menuArray[newComponentName].name, this.$customizerDataLayer.types.selectComponentArrow);
    },
    changeMenuItemVisibility(componentName, visible) {
      this.$store.commit("legacyNavigation/CHANGE_MENU_ITEM_VISIBILITY", { componentName, visible });
    },
    updateMenuItemState(componentToUpdate) {
      const componentName = componentToUpdate || this.activeComponent;
      this.$store.commit("legacyNavigation/UPDATE_MENU_ITEM_STATE", { componentName });
    },
    disableUGCIcons(disabled) {
      this.areUGCIconsDisabled = disabled;
    },
    disablePersonalizationIcon(disabled) {
      this.isPersonalizationIconDisabled = disabled;
    },
    setDataLayer(componentName, type) {
      this.$customizerDataLayer.logAnalyticsEvent({ model: this.pdm.sku, componentName, type });
    }
  },
  created() {
    this.$eventBus.$on("create-your-own-is-disabled", this.disableUGCIcons);
    this.$eventBus.$on("personalization-is-disabled", this.disablePersonalizationIcon);
    this.$eventBus.$on("select-component", this.selectComponent);
    this.$eventBus.$on("change-menu-item-visibility", this.changeMenuItemVisibility);
    this.$eventBus.$on("update-menu-item-state", this.updateMenuItemState);
  },
  beforeDestroy() {
    this.$eventBus.$off("create-your-own-is-disabled", this.disableUGCIcons);
    this.$eventBus.$off("personalization-is-disabled", this.disablePersonalizationIcon);
    this.$eventBus.$off("select-component", this.selectComponent);
    this.$eventBus.$off("change-menu-item-visibility", this.changeMenuItemVisibility);
    this.$eventBus.$off("update-menu-item-state", this.updateMenuItemState);
  }
}
</script>
